export default __webpack_public_path__ + "static/thumbnailBg-5e03759167c48671dc81343622749232.png";